/**
 * Enum Cấp ngân sách
 */
export default {
    /**Đơn vị hành chính tự chủ kinh phí */
    SeflFunding: 1,
    /**Đơn vị hành chính không được giao tự chủ kinh phí */
    NoSeflFunding: 2,
    /**Đơn vị SNCL tự chủ một phần chi thường xuyên */
    PublicAnyRegular: 3,
    /**Đơn vị SNCL tự đảm bảo CTX và chi đầu tư */
    PublicRegularInvest: 4,
    /**Đơn vị SNCL tự đảm bảo chi tx */
    PublicRegular: 5,
    /**Đơn vị SNCL nhà nước đảm bảo chi TX */
    PublicGovernment: 6,
    /**Khác */
    Other: 7
};
